import Repository from "./Repository";

const formDataConfig = {
  headers: { "Content-Type": "multipart/form-data" },
};

const ADD_AUTHOR = "create";
const DELETE_AUTHOR = "delete";
const GET_AUTHOR = "get";
const EDIT_AUTHOR = "edit";

export default {
  createAuthor(payload) {
    return Repository.post(transformRoute(ADD_AUTHOR), payload);
  },
  deleteAuthor(payload) {
    return Repository.post(transformRoute(DELETE_AUTHOR), payload);
  },
  getAuthor(payload) {
    return Repository.post(transformRoute(GET_AUTHOR), payload);
  },
  editAuthor(payload) {
    return Repository.post(transformRoute(EDIT_AUTHOR), payload);
  },
};

const transformRoute = (route) => {
  return `cms/author/${route}`;
};
